<template>
  <div class="t-more" v-if="text">
    <i v-if="icon" class="icon loading icon-loading"></i>
    <span>{{text}}</span>
  </div>
</template>
<script>
/**
   * @param icon [String] 是否加载动画
   * @param text [text] 加载文字
   * @describe 适应于分页加载动画
   *
   * @example
   *
    <t-more icon="" text=""></t-more>
   */

export default {
  name: 'tMore',
  props: {
    icon: { type: Boolean, default: false },
    text: { type: String, default: '加载中...' },
  },
};

</script>
<style scoped lang="scss">
.t-more {
  padding: 0.15rem 0;
  line-height: 0.16rem;
  font-size: 0.14rem;
  text-align: center;
  i {
    display: inline-block;
    vertical-align: middle;
    color: #cfcfcf;
  }
  span {
    display: inline-block;
    vertical-align: middle;
    color: #cfcfcf;
    margin-left: 0.02rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/more.vue